import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@shopify/polaris';
import { capitalize } from 'lodash';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  name: PropTypes.string.isRequired,

  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,

  label: PropTypes.string,
  type: PropTypes.string,

  invertHandleChange: PropTypes.bool, // Hacky way to make it easier to use Formik with Polaris TextFields. TODO eventually this should be the default way for all BasicTextField components.
};

const defaultProps = {
  type: "text",
  invertHandleChange: false,
}


const BasicTextField = (props) => {
  const { name, label, type, handleChange, handleBlur, values, errors, touched, error, ...otherProps } = props;
  let errorMessage;
  if(touched){ // handling with touched props (errors only displayed if field has been touched)
    errorMessage = !!touched[name] && errors[name];
  }
  else{ // just display error if exists
    errorMessage = error || (errors && errors[name]);
  }

  const handleChangeCallback = props.invertHandleChange ? (value, id) => handleChange(id, value) : handleChange; 

  return(
    <TextField
      id={ name }
      name={ name }
      label={ label || capitalize(name) }
      type={ type }
      onBlur={ handleBlur }
    
      onChange={ handleChangeCallback }
      value={ typeof(values[name]) === "number" && values[name]  ? values[name].toString() : values[name] }
      error={ errorMessage }
      {...otherProps}
    />
  )
};

BasicTextField.propTypes = propTypes;
BasicTextField.defaultProps = defaultProps;


export default BasicTextField;
